// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ficha-levantamento-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f7f9fa;
    max-width: 800px;
    margin: 0 auto;
}

.fl-content-wrapper {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 20px;
    margin-bottom: 20px;
}

.fl-form-group {
    margin-bottom: 20px;
}

.fl-form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #2c3e50;
    font-size: 14px;
}

.fl-form-group select {
    width: 100%;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 16px;
    background-color: #f8fafc;
    color: #1e293b;
}

.fl-section-block {
    background: #f8fafc;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid #e2e8f0;
}

.fl-section-title {
    margin-top: 0;
    margin-bottom: 15px;
    color: #1a56db;
    font-size: 18px;
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 8px;
}

.fl-question-row {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px dashed #cbd5e1;
}

.fl-question-row:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.fl-question-label {
    font-weight: 600;
    color: #334155;
    margin-bottom: 8px;
    font-size: 15px;
}

.fl-inputs-row {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
}

.fl-sn-toggle {
    display: flex;
    gap: 5px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    padding: 3px;
    background: #fff;
}

.fl-btn {
    padding: 8px 16px;
    border: none;
    background: transparent;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
}

.fl-btn.active-s {
    background: #10b981;
    color: white;
}

.fl-btn.active-n {
    background: #ef4444;
    color: white;
}

.fl-val-input, .fl-obs-input {
    flex: 1 1;
    min-width: 100px;
    padding: 10px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 14px;
}

.fl-obs-input {
    min-width: 180px;
}

.photo-upload-wrapper {
    margin-bottom: 15px;
}

.photo-upload-wrapper input[type="file"] {
    display: none;
}

.photo-upload-wrapper .upload-btn {
    display: inline-block;
    padding: 12px 20px;
    background-color: #3b82f6;
    color: white;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    text-align: center;
    width: 100%;
}

.photo-upload-wrapper .upload-btn.disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
}

.photo-preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
}

.photo-thumbnail {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    height: 100px;
}

.photo-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.remove-photo-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(239, 68, 68, 0.9);
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    font-weight: bold;
}

.fl-submit-btn {
    width: 100%;
    padding: 15px;
    background-color: #10b981;
    color: white;
    font-weight: bold;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    margin-top: 20px;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
}

.fl-submit-btn:disabled {
    background-color: #a7f3d0;
    cursor: not-allowed;
}

.fl-message {
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-weight: 500;
}

.fl-message.error {
    background-color: #fee2e2;
    color: #ef4444;
}

.fl-message.success {
    background-color: #d1fae5;
    color: #059669;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FichaLevantamento.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".ficha-levantamento-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100vh;\r\n    background-color: #f7f9fa;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.fl-content-wrapper {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n    padding: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.fl-form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.fl-form-group label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: 600;\r\n    color: #2c3e50;\r\n    font-size: 14px;\r\n}\r\n\r\n.fl-form-group select {\r\n    width: 100%;\r\n    padding: 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    background-color: #f8fafc;\r\n    color: #1e293b;\r\n}\r\n\r\n.fl-section-block {\r\n    background: #f8fafc;\r\n    border-radius: 10px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #e2e8f0;\r\n}\r\n\r\n.fl-section-title {\r\n    margin-top: 0;\r\n    margin-bottom: 15px;\r\n    color: #1a56db;\r\n    font-size: 18px;\r\n    border-bottom: 2px solid #e2e8f0;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.fl-question-row {\r\n    margin-bottom: 15px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px dashed #cbd5e1;\r\n}\r\n\r\n.fl-question-row:last-child {\r\n    border-bottom: none;\r\n    margin-bottom: 0;\r\n    padding-bottom: 0;\r\n}\r\n\r\n.fl-question-label {\r\n    font-weight: 600;\r\n    color: #334155;\r\n    margin-bottom: 8px;\r\n    font-size: 15px;\r\n}\r\n\r\n.fl-inputs-row {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.fl-sn-toggle {\r\n    display: flex;\r\n    gap: 5px;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 6px;\r\n    padding: 3px;\r\n    background: #fff;\r\n}\r\n\r\n.fl-btn {\r\n    padding: 8px 16px;\r\n    border: none;\r\n    background: transparent;\r\n    border-radius: 4px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.fl-btn.active-s {\r\n    background: #10b981;\r\n    color: white;\r\n}\r\n\r\n.fl-btn.active-n {\r\n    background: #ef4444;\r\n    color: white;\r\n}\r\n\r\n.fl-val-input, .fl-obs-input {\r\n    flex: 1;\r\n    min-width: 100px;\r\n    padding: 10px;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n}\r\n\r\n.fl-obs-input {\r\n    min-width: 180px;\r\n}\r\n\r\n.photo-upload-wrapper {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.photo-upload-wrapper input[type=\"file\"] {\r\n    display: none;\r\n}\r\n\r\n.photo-upload-wrapper .upload-btn {\r\n    display: inline-block;\r\n    padding: 12px 20px;\r\n    background-color: #3b82f6;\r\n    color: white;\r\n    font-weight: 600;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.photo-upload-wrapper .upload-btn.disabled {\r\n    background-color: #9ca3af;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.photo-preview-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n    gap: 10px;\r\n}\r\n\r\n.photo-thumbnail {\r\n    position: relative;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    height: 100px;\r\n}\r\n\r\n.photo-thumbnail img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.remove-photo-btn {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 5px;\r\n    background: rgba(239, 68, 68, 0.9);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n}\r\n\r\n.fl-submit-btn {\r\n    width: 100%;\r\n    padding: 15px;\r\n    background-color: #10b981;\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    margin-top: 20px;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);\r\n}\r\n\r\n.fl-submit-btn:disabled {\r\n    background-color: #a7f3d0;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.fl-message {\r\n    padding: 15px;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n    font-weight: 500;\r\n}\r\n\r\n.fl-message.error {\r\n    background-color: #fee2e2;\r\n    color: #ef4444;\r\n}\r\n\r\n.fl-message.success {\r\n    background-color: #d1fae5;\r\n    color: #059669;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
